import { Routes } from '@angular/router';
import { RootRoutes } from './pages/core/root/root.routes';
import { LoginPage } from './pages/auth/login/login.page';
import { antiAuthGuard, authGuard } from './core/guards/auth.guard';
import { RootPage } from './pages/core/root/root.page';
import { deviceGuard } from './core/guards/device.guard';
import { MobileRootRoutes } from './pages/core/mobile/mobileRoot/root.mobile.routes';
import { RootMobilePage } from './pages/core/mobile/mobileRoot/root.mobile.page';

export const routes: Routes = [
    {
      path: 'auth',
      canActivate: [antiAuthGuard],
      children: [
        {
          path: 'login',
          component: LoginPage
        },
        {
          path: 'reset-password',
          component: LoginPage
        },
        {
          path: '',
          redirectTo: 'login',
          pathMatch: 'full',
        },
      ],
    },
    {
      path: "wita",
      component: RootPage,
      children: RootRoutes,
      canActivate: [authGuard, deviceGuard('desktop', '/witaMobile')]
    },
    {
      path: "witaMobile",
      component: RootMobilePage,
      children: MobileRootRoutes,
      canActivate: [authGuard, deviceGuard('mobile', '/wita')]
    },
    {
      path: '',
      redirectTo: 'wita',
      pathMatch: 'full',
    }
];
